import { InfoOutlined } from '@mui/icons-material';
import { Box, IconButton, Popover } from '@mui/material';
import { MouseEvent, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ArchiveHelper from './ArchiveHelper';
import JournalHelper from './JournalHelper';
import KitchenHelper from './KitchenHelper';
import MenuHelper from './MenuHelper';
import POSHelper from './POSHelper';
import ProductsHelper from './ProductsHelper';
import SalaryHelper from './SalaryHelper';
import SemiProductsHelper from './SemiProductsHelper';
import SettingsHelper from './SettingsHelper';
import StoresHelper from './StoresHelper';
import SupplyHelper from './SupplyHelper';
import TableMapHelper from './TableMapHelper';
import WalletsHelper from './WalletsHelper';
import WorkersHelper from './WorkersHelper';

const Helpers = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { pathname } = useLocation();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const Component = useMemo(() => {
    if (pathname.includes('/pos')) {
      return POSHelper;
    }
    if (pathname.includes('/kitchen')) {
      return KitchenHelper;
    }
    if (pathname.includes('/orderArchive')) {
      return ArchiveHelper;
    }
    if (pathname.includes('/stores')) {
      return StoresHelper;
    }
    if (pathname.includes('/supply')) {
      return SupplyHelper;
    }
    if (pathname.includes('/journal')) {
      return JournalHelper;
    }
    if (pathname.includes('/workers')) {
      return WorkersHelper;
    }
    if (pathname.includes('/wallets')) {
      return WalletsHelper;
    }
    if (pathname.includes('/salary')) {
      return SalaryHelper;
    }
    if (pathname.includes('/products')) {
      return ProductsHelper;
    }
    if (pathname.includes('/semifinished')) {
      return SemiProductsHelper;
    }
    if (pathname.includes('/menu')) {
      return MenuHelper;
    }
    if (pathname.includes('/restaurant')) {
      return SettingsHelper;
    }
    if (pathname.includes('/editTableMap')) {
      return TableMapHelper;
    }
    return null;
  }, [pathname]);

  if (Component === null) {
    return null;
  }

  return (
    <div>
      {open && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: (t) => t.palette.grey[900],
            opacity: 0.3,
            zIndex: (t) => t.zIndex.modal - 2,
          }}
        />
      )}

      <IconButton
        onClick={handleClick}
        sx={{
          zIndex: open ? (t) => t.zIndex.modal - 1 : undefined,
          bgcolor: (t) => (open ? t.palette.background.paper : t.palette.background.default),
          borderBottomLeftRadius: open ? 0 : undefined,
          borderBottomRightRadius: open ? 0 : undefined,
        }}
      >
        <InfoOutlined />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{ mx: 2 }}
      >
        <Box sx={{ maxWidth: 600, maxHeight: '80vh', m: 2 }}>
          <Component />
        </Box>
      </Popover>
    </div>
  );
};

export default Helpers;
